<template>
    <price-tag-shell :context="context">
        <div class="pt-row pt-row--top pt-row--between">
            <price-tag-product :product="context.product" />
            <price-tag-discount :percent="firstTier.discountPercent" prefix="-">
                <template v-if="editable">
                    -<price-tag-value v-bind="bindField('percent')" />%
                </template>
            </price-tag-discount>
        </div>
        <div class="pt-row">
            <span class="pt-big-number">{{ formatMoney(firstTier.promoPrice) }}</span>
            <span class="pt-currency">{{ context.currencySymbol }}</span>
        </div>
        <div v-if="context.regularPrice" class="pt-small">
            {{
                tagText('regularPrice', {
                    price: formatMoney(context.regularPrice),
                    currency: context.currencySymbol,
                })
            }}
        </div>
    </price-tag-shell>
</template>

<script setup>
import { computed } from 'vue';
import {
    priceTagLayoutProps,
    priceTagLayoutEmits,
    usePriceTagLayout,
} from '@/js/composables/usePriceTagLayout';

const props = defineProps(priceTagLayoutProps);
const emit = defineEmits(priceTagLayoutEmits);

const { bindField, tagText, formatMoney } = usePriceTagLayout(props, emit);

const firstTier = computed(() => props.context.tiers[0] || {});
</script>

<style lang="scss" scoped>
@import '@style/price-tags/price-tag-layout';
</style>
